export default "__VITE_ASSET__CLf6er0G__"